import React from 'react';
import { NumberInput, NumberInputProps } from 'react-admin';

/**
 * Drop-in replacement for react-admin's `<NumberInput>` that prevents the
 * browser's default wheel-scroll-changes-value behaviour: scrolling the page
 * while a number input is focused would otherwise increment / decrement the
 * value as the wheel passes over the input. Blurring on wheel removes focus
 * before the increment is applied while the wheel still propagates so the
 * page scrolls normally.
 *
 * Behaviour is identical to `<NumberInput>` otherwise — same props, same
 * react-hook-form wiring, same validation. Caller-provided `inputProps`
 * with their own `onWheel` will override the default.
 */
const blurOnWheel = (e: React.WheelEvent<HTMLInputElement>) => {
    (e.target as HTMLInputElement).blur();
};

export const WheelSafeNumberInput: React.FC<NumberInputProps> = ({
    inputProps,
    ...rest
}) => (
    <NumberInput
        {...rest}
        inputProps={{ onWheel: blurOnWheel, ...inputProps }}
    />
);
